import { render } from "./UpdateRoutingForm.vue?vue&type=template&id=6625543c"
import script from "./UpdateRoutingForm.vue?vue&type=script&lang=js"
export * from "./UpdateRoutingForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__